import { Injectable } from '@angular/core';
import { LogConfig, Logger } from '@privatelib/logger-frontend';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CvaLoggerService {
  logConfig: LogConfig | undefined;

  constructor() {
    this.logConfig = new LogConfig();
    this.logConfig.servicename = 'CVA-UX';
    this.logConfig.environment = environment.environment;
    this.logConfig.logBatchSize = 5;
    this.logConfig.ipResolutionEndpoint = environment.loggerConfig.ipResolutionEndPoint;
    this.logConfig.logCollectionEndpoint = environment.loggerConfig.loggerEndPoint;
    this.logConfig.debug = environment.loggerConfig.debug;
    this.logConfig.isCookieEnabled = false;
    Logger.getLogger(this.logConfig);
  }
}
